import { reaction } from 'mobx';
import { AppUI } from '@seedlang/state';

// Lets testers preview site colors by setting e.g. localStorage.accentColorOverride = '#e63946'.
// Only six-digit hex is accepted because consumers append alpha digits to the color.
const SIX_DIGIT_HEX = /^#?([0-9a-f]{6})$/i;

const applySiteColorOverride = (field) => {
  const match = localStorage.getItem(`${field}Override`)?.match(SIX_DIGIT_HEX);
  if (!match) return;
  const override = `#${match[1]}`;
  reaction(
    () => AppUI.site,
    (site) => site?.set(field, override),
    { fireImmediately: true },
  );
};

applySiteColorOverride('accentColor');
applySiteColorOverride('secondaryAccentColor');
